import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=52f964a1&scoped=true&"
import script from "./HomeView.vue?vue&type=script&lang=js&"
export * from "./HomeView.vue?vue&type=script&lang=js&"
import style0 from "./HomeView.vue?vue&type=style&index=0&id=52f964a1&prod&lang=css&"
import style1 from "./HomeView.vue?vue&type=style&index=1&id=52f964a1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f964a1",
  null
  
)

export default component.exports